export default __webpack_public_path__ + "static/media/Copy of The Kruks Photography-300_tn.598cb33d.jpg";